export default __webpack_public_path__ + "static/media/uploader-abbottNeo-problem-2.adefc8a8.png";